import { combineReducers, configureStore } from "@reduxjs/toolkit";

import geocodingReducer from "reducers/geocoding";
import settingsReducer from "reducers/settings";
import sovReducer from "reducers/sov";
import salReducer from "reducers/sal";
import pliReducer from "reducers/pli";
import mapWorkspaceReducer from "reducers/map-workspace";
import overlaysReducer from "reducers/overlays";
import measurementsReducer from "reducers/measurements";
import buildingUpdatesReducer from "reducers/buildingUpdates";
import portfolioReducer from "reducers/portfolio";

import { authReducer, rtkQueryMapsErrorLogger } from "@repo/ping-react-js";
import { api } from "services/appSlice";

const baseReducers = {
  [api.reducerPath]: api.reducer,
  auth: authReducer,
  geo: geocodingReducer,
  settings: settingsReducer,
  sov: sovReducer,
  sal: salReducer,
  mapWorkspace: mapWorkspaceReducer,
  overlays: overlaysReducer,
  measurements: measurementsReducer,
  pli: pliReducer,
  buildingUpdates: buildingUpdatesReducer,
  portfolio: portfolioReducer,
};

const rootReducer = combineReducers(baseReducers);

export const setupStore = (preloadedState?: Partial<RootState>) => {
  return configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({ serializableCheck: false }).concat(
        api.middleware,
        rtkQueryMapsErrorLogger,
      ),
    preloadedState,
  });
};

export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore["dispatch"];
